import { Config } from '../../_config'
import { UseCase } from '../../_kernel/architecture'
import { ID } from '../../_kernel/ID'
import { ListOfID } from '../../_kernel/ListOfID'
import { PropertyRepository } from '../domain/PropertyRepository'
import { PropertyRepositoryProxy } from '../infrastructure/PropertyRepositoryProxy'

export interface AddByIDLastSeenPropertyUseCaseInput {
  id: number
}

export const PROPERTIES_VISITED_MAX = 8

export default class AddByIDLastSeenPropertyUseCase
  implements UseCase<AddByIDLastSeenPropertyUseCaseInput, ListOfID>
{
  static readonly USE_CASE_NAME = 'AddByIDLastSeenPropertyUseCase'
  static create({ config, repository }: { config: Config; repository?: PropertyRepository }) {
    return new AddByIDLastSeenPropertyUseCase(
      repository ?? PropertyRepositoryProxy.create({ config })
    )
  }

  constructor(private repository: PropertyRepository) {}

  async execute({ id }: AddByIDLastSeenPropertyUseCaseInput) {
    const currentIDs = await this.repository.lastSeenIDs()
    const nextIDs = currentIDs.addOne({
      id: ID.fromNumber({ value: id }),
      limit: PROPERTIES_VISITED_MAX,
    })

    const savedIDs = await this.repository.saveLastSeenIDs({ ids: nextIDs })
    return savedIDs
  }
}
